import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Users, Building2, Award, Newspaper, Calendar, CheckCircle2, Clock, ShieldCheck } from "lucide-react";

const CARDS = [
  ["total_registrations", "Total Pendaftar", FileText, "bg-emerald-50 text-emerald-700"],
  ["new_registrations", "Pendaftar Baru", Clock, "bg-amber-50 text-amber-700"],
  ["pending_verification", "Menunggu Verifikasi", Clock, "bg-blue-50 text-blue-700"],
  ["verified", "Terverifikasi", CheckCircle2, "bg-green-50 text-green-700"],
  ["total_assessors", "Total Asesor", Users, "bg-slate-50 text-slate-700"],
  ["total_tuk", "Total TUK", Building2, "bg-slate-50 text-slate-700"],
  ["total_schemes", "Total Skema", Award, "bg-slate-50 text-slate-700"],
  ["total_news", "Total Berita", Newspaper, "bg-slate-50 text-slate-700"],
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then(r => setStats(r.data)); }, []);
  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-emerald-950 mb-8">Dashboard</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map(([key, label, Icon, cls]) => (
          <div key={key} data-testid={`stat-${key}`} className="bg-white rounded-2xl p-6 border border-slate-100">
            <div className={`w-10 h-10 rounded-lg ${cls} flex items-center justify-center mb-3`}><Icon className="w-5 h-5" /></div>
            <div className="text-3xl font-display font-extrabold text-emerald-950">{stats[key] ?? 0}</div>
            <div className="text-sm text-slate-600 mt-1">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
